import { render, staticRenderFns } from "./Servicedetails.vue?vue&type=template&id=5031e7f8&scoped=true"
import script from "./Servicedetails.vue?vue&type=script&lang=js"
export * from "./Servicedetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031e7f8",
  null
  
)

export default component.exports